import {
  HIRE_DETAILS,
  HIRE_DETAILS_FAILED,
  HIRE_DETAILS_SUCCESS,
  SAVE_HIRE_DETAILS,
  SAVE_HIRE_DETAILS_FAILED,
  SAVE_HIRE_DETAILS_SUCCESS,
} from "./actionTypes";

export const getCandidateHiringDetails = (jobId, candidateId) => {
  return {
    type: HIRE_DETAILS,
    payload: { jobId, candidateId },
  };
};
export const getCandidateHiringDetailsFailed = (error) => {
  return {
    type: HIRE_DETAILS_FAILED,
    payload: { error },
  };
};
export const getCandidateHiringDetailsSuccess = (success) => {
  return {
    type: HIRE_DETAILS_SUCCESS,
    payload: success,
  };
};

export const saveHiringDetails = (data) => {
  return {
    type: SAVE_HIRE_DETAILS,
    payload: { data },
  };
};
export const saveHiringDetailsFalied = (error) => {
  return {
    type: SAVE_HIRE_DETAILS_FAILED,
    payload: error,
  };
};
export const saveHiringDetailsSuccess = (success) => {
  return {
    type: SAVE_HIRE_DETAILS_SUCCESS,
    payload: success,
  };
};
